module.exports = __webpack_public_path__ + "img/banner.b4cb580f.jpg";